/**
 * @Author: wuyang
 * @Date: 2024/1/9
 * @Description: ""
 */
import { UserInfoService } from '@/helper/services/userinfo/UserInfoService'
import { getSocketIOInstance } from '@/api/socket'
import {webSocketFn} from '@/helper/services/socket/websocket'
import { createSocketService } from '@/helper/services/socket/SocketService'
import { ESocketPushType } from '@/types/socket'

export const userinfoService = (function () {
	const socketService = createSocketService({})
	const uis = new UserInfoService({
		handleMitt: {
			onLogin(userinfo) {
				getSocketIOInstance().connect(userinfo.userId)
        // webSocketFn()
				console.log('websocket发起连接', userinfo.userId)
			},
			onLogout() {
				getSocketIOInstance().disConnect()
				console.log('www--------->onlogout')
			},
			onPayStatus(data) {
				uis.refresh()
			}
		}
	})

	socketService.on(ESocketPushType.payStatus, (data) => {
		uis.mitt.emit('onPayStatus', data)
	})

	console.log('www--------userinfoService->', uis)
	return uis
})()
